module.exports = __webpack_public_path__ + "img/BUZONWEB.1d213649.svg";